import React, { useEffect } from 'react';

import AddIcon from '@mui/icons-material/Add';
import { useFormContext } from 'react-hook-form';
import { Box } from 'shared/mui/Box';
import { Button } from 'shared/mui/Buttons';
import { Typography } from 'shared/mui/Typography';

import { CommissionsCreateFormValues } from './CommissionsCreateForm';
import { CommissionsCreateLadderStep } from './CommissionsCreateLadderStep/CommissionsCreateLadderStep';
import { useLadderField } from './hooks/useLadderField';

export const CommissionsCreateLadderSteps = () => {
  const form = useFormContext<CommissionsCreateFormValues>();

  const { stepsFields, onAddStepClick, onRemoveStepClick } = useLadderField({
    name: 'ladder.steps',
    form,
  });

  const stepsWatched = form.watch('ladder.steps');
  const hasLastStep = !!stepsWatched?.some((step) => step?.isLastStep);

  useEffect(() => {
    stepsFields.forEach((_, index) => {
      form.setValue(`ladder.steps.${index}.stepNumber`, index + 1, {
        shouldValidate: false,
        shouldDirty: false,
      });
    });
  }, [stepsFields.length, form.setValue]);

  return (
    <Box alignItems="flex-start" display="flex" flexDirection="column" mb={3} rowGap={2}>
      <Typography fontWeight={500} variant="body1">
        Добавление ступеней
      </Typography>
      {stepsFields.map((_, index) => {
        return (
          <CommissionsCreateLadderStep
            key={index}
            onRemoveStepClick={onRemoveStepClick}
            stepIndex={index}
          />
        );
      })}
      <Button
        disabled={hasLastStep}
        label="Добавить ступень"
        onClick={onAddStepClick}
        startIcon={<AddIcon />}
        variant="outlined"
      />
    </Box>
  );
};
